import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
];

export const TeacherRoutingProvider = RouterModule.forRoot(routes, { useHash: true });